/**
 * 사이드 메뉴
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { udfLogOut, AlertModal } from '../../common/common';
import SideNav, { NavItem, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import logoBi from '../../logo-bi.png';
import { udfSetScInfo, udfSetRuleHistoryReload } from '../../common/usr/stdtList';

class SideMenuCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      history: this.props.history,

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: '',

      showSchoolBBS: false,

      usrInfo: this.props.usrInfo,

    }
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      alertShow: props.alertShow,
      alertClickNo: props.alertClickNo === undefined ? null : props.alertClickNo,
      alertClickYes: props.alertClickYes === undefined ? null : props.alertClickYes,
      alertClickOk: props.alertClickOk === undefined ? null : props.alertClickOk,
      alertMessage: props.alertMessage === undefined ? null : props.alertMessage,
    });
  }

  componentWillUnmount = () => {
    this.udfSideMenuHide();
  }

  componentDidMount = () => {
    $('.sidenav---sidenav-toggle---1KRjR').each(function (index, e) {
      if ($(e).attr('aria-expanded') === 'true') {
        $(e).click();
      }
    });

    // 로그아웃 버튼 바인딩
    $('.logoutBtn').on('click', () => {
      udfLogOut(this);
      $('.sidenav---sidenav-toggle---1KRjR').each(function (index, e) {
        if ($(e).attr('aria-expanded') === 'true')
          $(e).click();
      });
    });

    let switchFlag = false;

    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.state.history !== null && typeof (this.state.history) !== undefined && !switchFlag) {
        switchFlag = true;
        this.state.history.go(-1);
      }
    });
  }

  componentDidUpdate = () => {
    if (this.props.usrInfo && this.props.usrInfo.BBS_YN === 'Y' && !this.state.showSchoolBBS) {
      this.setState({ showSchoolBBS: true });
    }

    if (this.props.usrInfo && this.props.usrInfo.BBS_YN === 'N' && this.state.showSchoolBBS) {
      this.setState({ showSchoolBBS: false });
    }

    // modal 출력 순서에 따른 backdrop z-index 처리
    $.each($('.modal-backdrop'), function (i, v) {
      if (i > 0) {
        $(v).css('z-index', $($('.modal')[i - 1]).css('z-index'));
      }
    });
  }

  // 메뉴 영역 숨기기
  udfSideMenuHide = () => {
    // 길이
    $('.sidenav---sidenav---_2tBP').css('height', '');
    $('.sidenav---sidenav---_2tBP').css('z-index', '1050');

    // 메뉴 HIDE
    $('.sidenav---sidenav-nav---3tvij').css('display', 'none');
    $('.sidenav---sidenav-nav---3tvij').removeClass('sidenav---expanded---1KdUL');

    // HOME, LOGOUT 버튼
    $('.sideShortIcon').removeClass('d-inline-bock');
    $('.sideShortIcon').addClass('d-none');

    // 메뉴 배경 어둡게 처리
    $('.menuBg').addClass('d-none');
    $('.sidenav---sidenav-toggle---1KRjR').each(function (index, e) {
      if ($(e).attr('aria-expanded') === 'true')
        $(e).click();
    });
  }

  // 메뉴 영역 출력
  udfSideMenuShow = () => {
    // if (this.state.usrInfo.id !== '') $('.userId').text(this.state.usrInfo.id + '님 ');

    // 길이
    $('.sidenav---sidenav---_2tBP').css('height', '100vh');
    $('.sidenav---sidenav---_2tBP').css('z-index', '1052');

    // 닫기 버튼 위치 변경
    $('.sidenav---sidenav-toggle---1KRjR').css('float', 'right');

    // 메뉴 show
    $('.sidenav---sidenav-nav---3tvij').css('display', 'inline');
    $('.sidenav---sidenav-nav---3tvij').addClass('sidenav---expanded---1KdUL');

    // HOME, LOGOUT 버튼
    $('.sideShortIcon').removeClass('d-none');
    $('.sideShortIcon').addClass('d-inline-bock');

    // 메뉴 배경 어둡게 처리
    $('.menuBg').removeClass('d-none');
  }

  handleClose = () => {
    this.setState({ alertShow: false });
  }

  render() {
    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.handleClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        <div className="menuBg wrap-loading-menu d-none" onClick={() => {
          // 사이드 메뉴가 열려 있으면 강제 닫기
          $('.sidenav---sidenav-toggle---1KRjR').each(function (index, e) {
            if ($(e).attr('aria-expanded') === 'true')
              $(e).click();
          });
        }}></div>
        <SideNav
          className='App-color'
          style={{ zIndex: '1050' }}
          onToggle={(flag) => {
            if (flag) {
              this.udfSideMenuShow();
            } else {
              this.udfSideMenuHide();
            }
          }}
        >

          <SideNav.Toggle style={{ height: '54px' }} />
          <div>
            <div className='sideShortIcon d-none' onClick={() => udfLogOut(this)}>
              <span style={{ fontSize: '0.8rem', paddingBottom: '.5rem', display: 'flex', float: 'left', paddingLeft: '1rem', paddingRight: '.5rem' }}>
                {this.props.usrInfo ? this.props.usrInfo.id : ''}님 로그아웃</span>
              <div className='logoutBtn d-inline-block'><FontAwesomeIcon icon={faSignOutAlt} /></div>
            </div>

            <SideNav.Nav className="text-left" style={{ display: 'none', backgroundColor: 'rgb(88, 162, 152)', height: '1200px' }}>
              <Link to='/menuList' onClick={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  this.props.history.push('/menuList');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }}>
                  <NavText style={{ fontWeight: 'normal', fontSize: '.8rem' }}>
                    <img src={logoBi} alt="스쿨라이프" style={{ height: "30px" }} />
                    <span style={{ float: 'right' }} className="pt-1 pr-2">맨 처음으로</span>
                  </NavText>
                </NavItem>
              </Link>
              <Link to='/usr/stdtList' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  udfSetScInfo('stdt', true, true);
                  this.props.history.push('/usr/stdtList');
                }, 500);
              }}
              >
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='stdtList' id='stdtList'>
                  <NavText style={{ fontWeight: 'normal' }}>
                    학생정보
                  </NavText>
                </NavItem>
              </Link>
              <Link to='/usr/ruleHistory' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  udfSetRuleHistoryReload(true);
                  this.props.history.push('/usr/ruleHistory');
                }, 500);
              }}
              >
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='ruleHistory' id='ruleHistory'>
                  <NavText style={{ fontWeight: 'normal' }}>
                    {this.props.usrInfo ? this.props.usrInfo.BLUE_NM : '상점'}/{this.props.usrInfo ? this.props.usrInfo.RED_NM : '벌점'} (개인별)
                  </NavText>
                </NavItem>
              </Link>
              <Link to='/usr/ruleRpt' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  udfSetScInfo('rule', true, true);
                  this.props.history.push('/usr/ruleRpt');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='ruleRpt' id='ruleRpt'>
                  <NavText style={{ fontWeight: 'normal' }}>{this.props.usrInfo ? this.props.usrInfo.BLUE_NM : '상점'}/{this.props.usrInfo ? this.props.usrInfo.RED_NM : '벌점'} 현황</NavText>
                </NavItem>
              </Link>
              <Link to='/usr/deductList' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  udfSetScInfo('deduct', true, true);
                  this.props.history.push('/usr/deductList');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='deductList' id='deductList'>
                  <NavText style={{ fontWeight: 'normal' }}>지도 후 차감 관리</NavText>
                </NavItem>
              </Link>
              <Link to='/usr/notice/BBSMSTR_000000000001' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  this.props.history.push('/usr/notice/BBSMSTR_000000000001');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='notice' id='notice'>
                  <NavText style={{ fontWeight: 'normal' }}>공지사항</NavText>
                </NavItem>
              </Link>
              {
                this.state.showSchoolBBS ?
                  <Link to='/usr/notice/school/BBSMSTR_000000000002' onMouseDown={() => {
                    this.udfSideMenuHide();
                    setTimeout(() => {
                      this.props.history.push('/usr/notice/school/BBSMSTR_000000000002');
                    }, 500);
                  }}>
                    <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='notice' id='notice'>
                      <NavText style={{ fontWeight: 'normal' }}>학교게시물</NavText>
                    </NavItem>
                  </Link> : null
              }
              <Link to='/usr/upnews/BBSMSTR_000000000011' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  this.props.history.push('/usr/upnews/BBSMSTR_000000000011');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='notice' id='notice'>
                  <NavText style={{ fontWeight: 'normal' }}>업데이트 소식</NavText>
                </NavItem>
              </Link>
              <Link to='/usr/qna/BBSMSTR_000000000021' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  this.props.history.push('/usr/qna/BBSMSTR_000000000021');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='qna' id='qna'>
                  <NavText style={{ fontWeight: 'normal' }}>1:1상담</NavText>
                </NavItem>
              </Link>
              <Link to='/usr/updatePwd' onMouseDown={() => {
                this.udfSideMenuHide();
                setTimeout(() => {
                  this.props.history.push('/usr/updatePwd');
                }, 500);
              }}>
                <NavItem className="pl-1 ml-2 mr-2 pt-3 pb-3" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#61aba1" }} eventKey='updatePwd' id='updatePwd'>
                  <NavText style={{ fontWeight: 'normal' }}>비밀번호 변경 및<br />이메일 인증 등록</NavText>
                </NavItem>
              </Link>
            </SideNav.Nav>
          </div>
        </SideNav>
        {/* </ClickOutside> */}
      </>
    );
  }
}

export default SideMenuCmp;